export default class Delay {

    public static FromMS(ms: number): Promise<void> {

        return new Promise<void>((resolve, _) => {

            setTimeout(() => {

                resolve();

            }, ms);

        });


    }

}